import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const TrendLineIcon = (props) => (
    <SvgIcon viewBox="0 0 19 14" sx={{ height: '14px', width: 'auto', ...props }}>
        <line
            x1="18.5996"
            y1="13.0074"
            x2="0.500294"
            y2="13.0074"
            stroke="currentColor"
            strokeWidth="1.17"
        />
        <line
            x1="1.085"
            y1="0.577667"
            x2="1.085"
            y2="13.4223"
            stroke="currentColor"
            strokeWidth="1.17"
        />
        <path
            d="M1.5 13L7 6.71432L11 8.28574L17.5 2.00003"
            stroke="currentColor"
            strokeWidth="1.17"
            fill="none"
        />
    </SvgIcon>
);

export default TrendLineIcon;
